<template>
  <!-- 根据是否显示行业专区更换皮肤 -->
  <div class="layout-header-container" :class="{ 'layout-header-container-industry-zone': isShowIndustryZone }">
    <div class="full-screen-width" />

    <div class="solid-1200px-width" id="layout_header">
      <!-- 左侧 -->
      <div class="left" @click="handleLogoClick">
        <img
          class="img_logo"
          :src="
            require(isShowIndustryZone ? '@/assets/img/SearchBar/logo-white.png' : '@/assets/img/SearchBar/logo.png')
          "
          alt="logo"
        />
      </div>

      <!-- 搜索栏 -->
      <SearchBar id="layout_header_center" />

      <!-- 右侧 -->
      <div id="layout_header_right" class="right">
        <ProductServicesButtonModule
          v-if="hasProductServices"
          :oIdMap="{
            EXPOSURE: OID_MAP.PRODUCTS_SERVICES_HEADER_BOX_CENTER_EXPOSURE,
            CLICK: OID_MAP.PRODUCTS_SERVICES_HEADER_BOX_CENTER_CLICK,
          }"
        />
        <!-- 热线电话 -->
        <div class="hot_line">
          <i class="iconfont icon-phone1" />
          {{ getServicePhone() }}
        </div>
        <!-- 用户信息 -->
        <div class="user_info" @mouseenter="handleUserMouseOver('enter')" @mouseleave="handleUserMouseOver('leave')">
          <!-- 头像 -->
          <img class="avatar" :src="avatar" alt="avatar" width="32" height="32" />
          <!-- 昵称 -->
          <!-- <div class="nickname">
            {{ userInfo.linkName || "未命名" }}
          </div> -->
          <!-- 箭头 -->
          <!-- <i :class="`iconfont icon-arrow-down-sm ${isShowPopupUser || isShowPopupHelpCenter ? 'rotate' : ''}`" /> -->
          <!-- 用户信息 弹窗 -->
          <PopupUser
            @mouseenter="handleUserMouseOver('enter')"
            @mouseleave="handleUserMouseOver('leave')"
            :open="isShowPopupUser"
            @cell="handlePopupUserClick"
          />
          <!-- 帮助中心 弹窗 -->
          <PopupHelpCenter
            :open="isShowPopupHelpCenter"
            @cell="handleHelpCenterCellClick"
            @help-center-modal-click="isShowPopupHelpCenter = false"
            @help-center-go-back="
              isShowPopupUser = true;
              isShowPopupHelpCenter = false;
            "
          />
        </div>
      </div>
    </div>

    <!-- 行业专区 -->
    <IndustryZone v-if="isShowIndustryZone" />

    <!-- 智能订阅 弹窗 -->
    <DialogSmartSubscribe />

    <!-- 智能订阅成功 弹窗 -->
    <DialogSmartSubscribeSuccess />

    <!-- 智能订阅失败 弹窗 -->
    <DialogSmartSubscribeError />
  </div>
</template>

<script>
import SearchBar from "@/components/LayoutHeaderSearch/SearchBar/SearchBar";
import PopupUser from "@/components/LayoutHeaderSearch/components/PopupUserV2";
import PopupHelpCenter from "@/components/LayoutHeaderSearch/components/PopupHelpCenter";
import { OFFICIAL_WEBSITE } from "@/utils/constants/constants";
import { getServicePhone, authCheck } from "@/utils/common";
import IndustryZone from "@/components/LayoutHeaderSearch/components/IndustryZone";
import DialogSmartSubscribe from "@/components/LayoutHeaderSearch/components/DialogSmartSubscribe/DialogSmartSubscribe";
import DialogSmartSubscribeSuccess from "@/components/LayoutHeaderSearch/components/DialogSmartSubscribe/DialogSmartSubscribeSuccess";
import DialogSmartSubscribeError from "@/components/LayoutHeaderSearch/components/DialogSmartSubscribe/DialogSmartSubscribeError";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";
import ProductServicesButtonModule from "@/components/common/ProductServicesButtonModule";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";

let popupUserCloseTimer;
export default {
  name: "LayoutHeaderSearch",
  data() {
    return {
      isShowPopupUser: false, // 用户信息
      isShowPopupHelpCenter: false, // 帮助中心
      OID_MAP,
      AUTH_KEY_MAP,
    };
  },
  components: {
    DialogSmartSubscribeError,
    DialogSmartSubscribeSuccess,
    DialogSmartSubscribe,
    IndustryZone,
    SearchBar,
    PopupHelpCenter,
    PopupUser, // 用户信息
    ProductServicesButtonModule,
  },
  computed: {
    isShowIndustryZone() {
      return this.$store.getters["industryZone/isShowIndustryZone"];
    },
    isSimulatedLogin() {
      return this.$store.getters["basic/isSimulatedLogin"];
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    avatar() {
      switch (true) {
        case !this.isShowIndustryZone && this.userInfo.sex === "m":
          return require(`@/assets/img/SearchBar/default_avatar.png`);
        case !this.isShowIndustryZone && this.userInfo.sex === "f":
          return require(`@/assets/img/SearchBar/default_avatar_f.png`);
        case this.isShowIndustryZone && this.userInfo.sex === "m":
          return require(`@/assets/img/SearchBar/default_avatar_industry_zone.png`);
        case this.isShowIndustryZone && this.userInfo.sex === "f":
          return require(`@/assets/img/SearchBar/default_avatar_f_industry_zone.png`);
        default:
          return require(`@/assets/img/SearchBar/default_avatar.png`);
      }
    },
    hasProductServices() {
      return authCheck(AUTH_KEY_MAP.HAS_PRODUCT_SERVICES_HEADER);
    },
  },
  methods: {
    // 用户信息中心 点击
    handlePopupUserClick(type) {
      switch (type) {
        case "upgrade":
          break;
        case "user-info":
          break;
        case "user-center":
          break;
        case "help-center":
          this.isShowPopupUser = false;
          this.isShowPopupHelpCenter = true;
          break;
        case "logout":
          break;
      }
    },
    // 获取咨询热线号码
    getServicePhone,
    // 鼠标移过用户信息
    handleUserMouseOver(status) {
      if (this.isShowPopupHelpCenter) return;
      clearTimeout(popupUserCloseTimer);
      if (status === "enter" && !this.isShowPopupUser) {
        this.isShowPopupUser = true;
      }
      if (status === "leave" && this.isShowPopupUser) {
        popupUserCloseTimer = setTimeout(() => {
          this.isShowPopupUser = false;
        }, 1000);
      }
    },
    // 左上角logo点击
    handleLogoClick() {
      window.location.href = OFFICIAL_WEBSITE;
    },
    // 帮助中心cell点击
    handleHelpCenterCellClick(item, index) {
      if (index === 0) {
        // 视频教程
        this.$track(DEED_MAP.CLICK, OID_MAP.HELP_CENTER_VIDEO_TUTORIAL_CLICK);
      }
      if (index === 1) {
        // 操作手册
        this.$track(DEED_MAP.CLICK, OID_MAP.HELP_CENTER_MANUAL_CLICK);
      }
      if (index === 2) {
        // 意见反馈
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config";

.layout-header-container {
  position: relative;

  .full-screen-width {
    width: 100%;
    height: $layout-header-height;

    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);
  }

  .solid-1200px-width {
    width: $layout-body-width;
    height: 100%;
    margin: 0 auto 0 calc(50% - calc($layout-body-width / 2));
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;

    .left {
      position: absolute;
      top: 23px;
      left: 82px;
      cursor: pointer;

      .img_logo {
        width: 97px;
        height: 54px;
      }
    }

    .right {
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;

      display: flex;
      align-items: center;

      padding-bottom: 19px;

      .user_info {
        display: flex;
        align-items: center;
        position: relative;

        .avatar {
          border-radius: 50%;
          flex-shrink: 0;
          cursor: pointer;
        }

        .nickname {
          // min-width: 38px;
          max-width: 84px;
          font-size: 14px;
          font-weight: 400;
          color: #45464a;
          line-height: 20px;

          margin-left: 12px;

          //单行
          word-break: break-all;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;

          cursor: pointer;

          .loading {
            font-size: 15px;
            margin-left: 10px;
          }
        }

        i {
          font-size: 8px;
          color: #666;
          margin-left: 4px;
          transition: all 0.2s linear;
        }

        .rotate {
          transform: rotate(180deg);
        }
      }

      .hot_line {
        // border: 1px solid $theme-color;
        // border-radius: 18px;
        // background-color: white;

        // font-weight: 400;
        // color: $theme-color;

        margin-right: 16px;
        margin-left: 16px;
        // padding: 5px 13px;

        i {
          margin-right: 3px;
          color: #a3a6ab;
        }
      }

      .help_center {
        border: 1px solid #dcdde1;
        border-radius: 18px;
        background-color: white;

        font-size: 12px;

        display: flex;
        align-items: center;

        margin-left: 20px;
        padding: 5px 12px;

        cursor: pointer;

        position: relative;

        i {
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
<!-- 根据是否显示行业专区更换皮肤 -->
<style scoped lang="scss" src="./LayoutHeaderSearch_IndustryZone.scss"></style>
